import React, { useState } from 'react'
import CustomerLogin from "./CsutomerLogin"
import CustomerRegister from './CustomerRegister'

export const LoginINdex = () => {
    const[login,setLogin]=useState(true)
    console.log("login",login)

  return (
    <>
    {login ? <CustomerLogin  setLogin={setLogin}/> :<CustomerRegister setLogin={setLogin}/>}
    </>
  )
}
